const header = document.querySelector('.header');

if (header) {
  const SCROLL_IN = 80;
  const SCROLL_OUT = 20;

  const onScroll = () => {
    const isScrolled = header.classList.contains('header--scrolled');

    if (!isScrolled && window.scrollY > SCROLL_IN) {
      header.classList.add('header--scrolled');
    } else if (isScrolled && window.scrollY < SCROLL_OUT) {
      header.classList.remove('header--scrolled');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}
